export default {"src":"/_next/static/media/icon-lock.19302519.svg","height":23,"width":18,"blurWidth":0,"blurHeight":0};